/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:6a4ae7ab-95bd-44d4-a0ae-172c0e115bbe",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_HDduVWpDx",
    "aws_user_pools_web_client_id": "626lpshepqcdjqehd5e5icp40m",
    "oauth": {
        "domain": "eu-central-1hdduvwpdx.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "http://localhost:4200/auth,https://d84l1y8p4kdic.cloudfront.net,https://pet-portal-testing.calingo.ch/auth",
        "redirectSignOut": "http://localhost:4200/auth,https://pet-portal-testing.calingo.ch/auth",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
